import { Translation } from "../../i18n";

export type MessageType = "danger" | "positive";

export class Message {
  public readonly timestamp = +new Date();

  constructor(
    public readonly message: string | Translation,
    public readonly type: MessageType = "positive",
    public readonly values: { [key: string]: any } = {}
  ) {}

  public static create(
    message: Translation | string,
    type?: MessageType,
    values?: { [key: string]: any }
  ) {
    return new Message(message, type, values);
  }
}
